import React from "react";
import { addEllipsisToText } from "../../../utils/utils";

// Mapping subStatus to display text
const statusMapping = [
  { combination: ["FJ"], status: "Pending Customer Consent" },
  { combination: ["YO"], status: "Pending for consent on revised BI & Revised Proposal form" },
  { combination: ["VV"], status: "Pending PIVC" },
  { combination: ["MP"], status: "Pending Medical Appointment" },
  { combination: ["NP"], status: "Pending Non Medical Document" },
  { combination: ["AI"], status: "Resubmit Pending Documents" },
  { combination: ["CO"], status: "Awaited acceptance on Counter Offer" },
  { combination: ["PM"], status: "Accepted " },
  { combination: ["PA"], status: "Payment awaited" },
  { combination: ["NM"], status: "Pending Medical & Non Medical" },
  { combination: ["AS"], status: "Form filling In Progress" },
  { combination: ["UD"], status: "Form filling Completed" },
  { combination: ["DC"], status: "Pending for QC" },
  { combination: ["AR"], status: "QC Discrepancy raised" },
  { combination: ["MA"], status: "Pending for Medical Appointment" },
  { combination: ["PB"], status: "Pending for internal decision" },
  { combination: ["RA"], status: "Pending for UW" },
  { combination: ["IP"], status: "Approved" },
  { combination: ["PI"], status: "Issued" },
  { combination: ["PD"], status: "Declined" },
  { combination: ["PP"], status: "Postponed" },
  { combination: ["PR"], status: "Rejected" },
  { combination: ["PC"], status: "Cancelled" },
];

// Generic function to find the status with the latest `updatedOn`
const getLatestStatus = (statuses) => {
  return statuses.reduce((latest, current) => {
    const latestDate = new Date(latest?.updatedOn || 0);
    const currentDate = new Date(current?.updatedOn || 0);
    return currentDate > latestDate ? current : latest;
  }, {});
};

const getStatusFromSubStatus = (subStatus) =>
  statusMapping.find((item) => item.combination.includes(subStatus));

const HeaderStatus = ({ bannerDetail, accordionListDetails, toggleAccordion, consentAccepted }) => {
  
  const findItem = (status) =>
    accordionListDetails?.find((item) => item.status === status);

  const findSubStatusByCondition = (conditionFn) =>
    accordionListDetails?.find(conditionFn)?.subStatus;

  const renderStatus = (text, className = 'header-link-text') => {
    // Get currentChildWS from QUOTE status item
    let currentChildWS = [];
    if (accordionListDetails && accordionListDetails?.length) {
      const firstAvailable = accordionListDetails?.find(
        (item) => item?.status === 'QUOTE'
      );
      currentChildWS = firstAvailable?.currentChildWS || [];
    }
    const newStatus = currentChildWS?.length
      ? " - " + currentChildWS?.join(", ")?.trim()
      : "";
    return (
      <div className={className}>
        Status: {addEllipsisToText(text)}
        {newStatus}
      </div>
    );
  };

  const renderHeaderBlk = (text) => (
    <div className="header-blk">
      {renderStatus(text)}
    </div>
  );

  const quote = findItem("QUOTE");
  const quote_subStatus = quote?.subStatus;
  const quote_status = getStatusFromSubStatus(quote_subStatus);
  const quote_updateOn = new Date(quote?.updatedOn || 0);

  const otherInProgress = accordionListDetails?.filter(
    (item) => item.status !== "QUOTE" && item.actual_status === "IN-PROGRESS" && item.subStatus
  );

  const latestOther = otherInProgress?.reduce((latest, current) =>
    new Date(current.updatedOn || 0) > new Date(latest?.updatedOn || 0) ? current : latest, null);
  
  // Special handling for YO
  if (quote_subStatus === "YO") {
    if (!latestOther || quote_updateOn >= new Date(latestOther?.updatedOn || 0)) {
      return <>{renderStatus(quote_status?.status)}</>;
    }
    const latestStatus = getStatusFromSubStatus(latestOther?.subStatus);
    return <>{renderStatus(latestStatus?.status)}</>;
  }

  const medical = findItem("MEDICAL_REQUIREMENT");
  const medical_status = getStatusFromSubStatus(medical?.subStatus);

  const addInfo = findItem("ADDITIONAL_NON_MEDICAL_REQUIREMENTS");
  const addInfo_status = getStatusFromSubStatus(addInfo?.subStatus);

  const co = findItem("REVISED_OFFER");
  const co_status = getStatusFromSubStatus(co?.subStatus);

  const payment = findItem("PAYMENT_REQUIREMENT");
  const payment_status = getStatusFromSubStatus(payment?.subStatus);

  const quality = findItem("QUALITY_CHECK");
  const quality_status = getStatusFromSubStatus(quality?.subStatus);

  const policy = findItem("POLICY_STATUS");
  const policy_status = getStatusFromSubStatus(policy?.subStatus);

  const instaVerify = accordionListDetails?.find((item) => item.subStatus === "INSTA_VERIFY_STATUS");
  const pivcStatus = instaVerify?.additionalInfo?.instaVerify?.pivcStatus;
  const isInstaRequired = instaVerify?.additionalInfo?.isInstaRequired;

  const subStatusInProgress = findSubStatusByCondition(
    (item) => item.actual_status === "IN-PROGRESS"
  );
  const other_status = getStatusFromSubStatus(subStatusInProgress);

  const isInsta = bannerDetail?.instaFlag === "INSTA";
  const hasPolicy = !!bannerDetail?.policyNumber?.trim();

  // Handling the special cases for DC and RA, PB, MA
  const qualityAndPolicyStatus = [
    quality,
    policy
  ].filter(item => item && item.subStatus && item.actual_status === "IN-PROGRESS");
  const latestStatusToShow = getLatestStatus(qualityAndPolicyStatus);
  if (latestStatusToShow && Object.keys(latestStatusToShow).length > 0) {
    const latestStatus = getStatusFromSubStatus(latestStatusToShow?.subStatus);
    return renderStatus(latestStatus?.status);
  }

  // Insta flow
  if (isInsta) {
    if (!hasPolicy && (quote_subStatus !== "FJ" || payment?.subStatus !== "PA")) {
      return renderHeaderBlk("Form filling In Progress");
    }
    if (quote_subStatus === "FJ" && quote?.actual_status === "IN-PROGRESS") {
      return renderStatus(quote_status?.status, "header-link");
    }
    if (payment?.subStatus === "PA" && payment?.actual_status === "IN-PROGRESS") {
      return renderStatus(payment_status?.status, "header-link");
    }
  } else {
    if (!hasPolicy) {
      return renderHeaderBlk("Form filling In Progress");
    }

    // Medical
    if (["NM", "MP"].includes(medical?.subStatus) && medical?.actual_status === "IN-PROGRESS") {
      return renderStatus(medical_status?.status, "header-link");
    }

    // Additional Info
    if (addInfo?.actual_status === "IN-PROGRESS") {
      if (addInfo?.subStatus === "AR") {
        return (
          <div className="header-blk">
            <div className="header-hover">{addInfo_status?.status}</div>
            {renderStatus(addInfo_status?.status)}
          </div>
        );
      }

      if (["AI", "NP"].includes(addInfo?.subStatus)) {
        return (
          <div className="header-container">
            <div className="header-hover">{addInfo_status?.status}</div>
            {renderStatus(addInfo_status?.status, "header-link")}
          </div>
        );
      }
    }

    // Counter Offer
    if (co?.subStatus === "CO" && co?.actual_status === "IN-PROGRESS") {
      return renderStatus(co_status?.status, "header-link");
    }

    // Payment
    if (payment?.subStatus === "PA" && payment?.actual_status === "IN-PROGRESS") {
      return renderStatus(payment_status?.status, "header-link");
    }

    // Policy Cancelled
    if (policy?.subStatus === "PC" && policy?.actual_status === "COMPLETED") {
      return renderStatus(policy_status?.status);
    }

    // Policy other statuses
    if (["RA", "PB", "MA"].includes(policy?.subStatus)) {
      return renderStatus(policy_status?.status);
    }

    // FJ handling
    if (quote_subStatus === "FJ" && !consentAccepted) {
      if (!isInstaRequired) return renderHeaderBlk(quote_status?.status);
      if (["APPROVED", "PARKED", "UnAssigned"].includes(pivcStatus)) {
        return renderHeaderBlk(quote_status?.status);
      }
      return renderHeaderBlk("Pending for PIVC");
    }

    // Quality Check
    if (quality?.subStatus && quality?.actual_status === "IN-PROGRESS") {
      return renderStatus(quality_status?.status);
    }

    // Quote status fallback
    if (["AS", "UD", "YO"].includes(quote_subStatus) && !consentAccepted) {
      return renderStatus(quote_status?.status);
    }

    if (quote_subStatus === "YO" && consentAccepted) {
      return renderStatus(quote_status?.status, "header-link");
    }

    if (quote_subStatus === "VV" && !consentAccepted) {
      return renderStatus(quote_status?.status, "header-link");
    }

    if (subStatusInProgress) {
      return renderStatus(other_status?.status, "header-link");
    }

    if (policy?.subStatus) {
      return renderStatus(policy_status?.status);
    }
  }

  return null;
};

export default HeaderStatus;